const $ = jQuery.noConflict();

'use strict';

const ChatSearch = {
	init: function() {
		this.bindEvents();
	},

	bindEvents: function() {
		$(document).on('input', '.js-company-chat__search-input', this.handleSearch);
	},

	handleSearch: function() {
		const searchValue = $(this).val().toLowerCase().trim(); // Get input value and normalize it

		$('.js-chat-users-for-search').each(function() {
			const userName = $(this).find('.js-company-chat__user-name').text().toLowerCase().trim();

			if (userName.includes(searchValue) || searchValue === '') {
				$(this).show(); // Show matching results
			} else {
				$(this).hide(); // Hide non-matching results
			}
		});
	}
};

export default ChatSearch;
